/**
 * Gate for the LEGACY listening / user-talking mixer clips (Aug 17 2026).
 *
 * Avatar.tsx still carries a pre-unified-controller code path that plays two
 * looping morph clips whenever `isListening` / `userTalking` flips:
 *   - blendDataListening.json   (subtle dimples + light smile)
 *   - blendDataUserTalking.json (historically a CONSTANT mouthSmile — its
 *     entire content is "grin at the user while they talk")
 *
 * In voice/live turns the unified non-speech controller + viseme playback own
 * those transitions, so the legacy clips must not also run. The March 2026
 * skip checked `isMobileCall || isWebrtcCall || isInVoiceCall` — but Visual
 * IVR (`/visual?token=...`) sets NONE of those: it joins an existing phone
 * call over the runtime websocket, and the runtime host forces `mode=live`
 * onto the URL, so the session runs with `isLiveMode` true instead. Result:
 * the unified controller AND the legacy clips both drove the face, and the
 * baked-in userTalking smile played the whole time the caller spoke — Keith's
 * Aug 17 2026 "while I am talking she puts a very strong smile on her face"
 * Visual IVR defect.
 *
 * Extracted as a pure helper so the flag coverage is unit-testable.
 */
export interface LegacyConversationClipFlags {
  /** Live mode (`mode=live`) — set for BOTH /live and /visual runtime-host routes. */
  isLiveMode?: boolean;
  isMobileCall?: boolean;
  isWebrtcCall?: boolean;
  isInVoiceCall?: boolean;
}

export function shouldSkipLegacyConversationClips(flags: LegacyConversationClipFlags): boolean {
  return Boolean(flags.isLiveMode || flags.isMobileCall || flags.isWebrtcCall || flags.isInVoiceCall);
}
